var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{ref:"masterDetail",attrs:{"confirmDeleteMessage":_vm.confirmDeleteMessage,"cols":_vm.cols,"hasExportCSV":false,"hasExportXLSX":false,"opts":_vm.opts,"customResource":_vm.customResource,"serverPagination":""}})}
var staticRenderFns = []

export { render, staticRenderFns }